export const MAX_TAGS_TO_SHOW = 2;
